import React, { useEffect, useState } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Badge,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Icons from "@/assets";
import useApiClient from "@/api/Client";
import ENDPOINTS from "@/api/endpoints";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { RootState } from "@/store";
import {
  setUnreadCount,
  setRefetchFlag,
} from "@/store/slices/notificationSlice";
const BottomNavBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { api } = useApiClient();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<number>(0);
  const { unreadCount } = useSelector((state: RootState) => state.notification);

  const { data: unreadData } = useQuery({
    queryKey: ["notifications", "unreadCount"],
    queryFn: async () => {
      const res = await api.get(ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
      return res?.data?.data?.unread_count || 0;
    },
    refetchInterval: 30000,
  });

  // useEffect(() => {
  //       const fetchUnreadCount = async () => {
  //     try {
  //       const res = await api.get(ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
  //       dispatch(setUnreadCount(res?.data?.data?.unread_count || 0));
  //     } catch (error) {
  //       console.error("Failed to fetch unread count:", error);
  //     }
  //   };

  //   fetchUnreadCount();
  // }, [api, dispatch]);

  useEffect(() => {
    if (unreadData !== undefined) {
      if (unreadData !== unreadCount) {
        dispatch(setUnreadCount(unreadData));
        if (location.pathname.includes("/profile")) {
          dispatch(setRefetchFlag(true));
        }
      }
    }
  }, [unreadData, dispatch, unreadCount, location.pathname]);

  const tabs = [
    {
      label: "Explore",
      icon: Icons.Explore,
      activeIcon: Icons.ExploreActive,
      path: "/explore",
    },
    {
      label: "Notification",
      icon: Icons.NoNotification,
      activeIcon: Icons.Notification,
      path: "/notifications",
    },
    {
      label: "Profile",
      icon: Icons.Profile,
      activeIcon: Icons.ProfileActive,
      path: "/profile",
    },
  ];

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    navigate(tabs[newValue].path);
  };

  const getActiveTab = () => {
    const { pathname, state } = location;

    if (pathname.startsWith("/dashboard")) return -1;
    if (pathname.startsWith("/explore")) return 0;
    if (pathname.startsWith("/notifications")) return 1;
    if (pathname.startsWith("/profile")) return 2;

    if (pathname.startsWith("/contribution/view")) {
      if (state?.from === "profile") return 2;
      if (state?.from === "dashboard") return -1;
      return 1; // Default to Notifications
    }

    return 0;
  };

  useEffect(() => {
    setActiveTab(getActiveTab());
  }, [location]);

  return (
    <BottomNavigation
      value={activeTab === -1 ? false : activeTab}
      onChange={handleChange}
      showLabels
      sx={{
        position: "fixed",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        maxWidth: { xs: "100%" },
        height: { xs: 68, sm: 64 },
        backgroundColor: "#fff",
        boxShadow: "0 -4px 12px rgba(0,0,0,0.1)",
        zIndex: 1000,
        "& .MuiBottomNavigationAction-label": {
          fontSize: { xs: 11, sm: 12 },
          fontWeight: 700,
          mt: { xs: "2%", sm: 1 },
          transition: "none",
        },
        "& .Mui-selected, & .Mui-selected .MuiBottomNavigationAction-label": {
          fontSize: { xs: 11, sm: 12 },
          transform: "none",
        },
      }}
    >
      {tabs.map((tab, index) => {
        const isActive = activeTab === index;
        return (
          <BottomNavigationAction
            key={tab.label}
            label={tab.label}
            icon={
              <Badge
                badgeContent={tab.label === "Notification" ? unreadCount : 0}
                sx={{
                  "& .MuiBadge-badge": {
                    top: 3,
                    right: 2,
                    backgroundColor: "#9D79F4",
                    color: "#fff",
                    fontSize: { xs: 11, sm: 12 },
                  },
                }}
              >
                <Box
                  sx={{
                    padding: "5%",
                    borderRadius: "50%",
                    background: isActive ? "#9443DF36" : "transparent",
                  }}
                >
                  <Box
                    sx={{
                      height: { xs: "5.83vw", sm: 24 },
                      width: { xs: "5.83vw", sm: 24 },
                    }}
                  >
                    <img
                      src={activeTab === index ? tab.activeIcon : tab.icon}
                      alt={tab.label}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Box>
                </Box>
              </Badge>
            }
            sx={{
              color: "#626262",
              "&.Mui-selected": {
                color: "#B17FE2",
                fontSize: { xs: 11, sm: 12 },
              },
            }}
          />
        );
      })}
    </BottomNavigation>
  );
};

export default React.memo(BottomNavBar);
